
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TitleService {
  constructor(private title: Title, private router: Router) {}
  titleTracking(): void {
    // Listen for navigation end events
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
         // Call method to get the title
        const browserTitle = this.generateTitleFromUrl();
        this.title.setTitle(browserTitle);
      });
  }

   generateTitleFromUrl(): string {
    const currentUrl = this.router.url.split('?')[0];
    // Split the URL path into segments and filter out numeric segments
    const urlSegments = currentUrl
      .split('/')
      .filter(segment => segment && !/^\d+$/.test(segment)); // Remove empty segments and numeric segments (id)
      // Default title
    if (urlSegments.length === 0) {
      return 'LitmusWorld'; 
    }
    // Convert the remaining segments to title case and join them with ' | '
    const title = urlSegments
      .map(segment => this.convertToTitleCase(segment)) 
      .join(' | '); 
    return   `LitmusWorld | ${title}` || 'LitmusWorld'
  }

  // convert a string into title
   convertToTitleCase(text: string): string {
    return text
      .split('-') // Split on hyphens for multi-word segments
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' '); 
  }
}
